import { render } from "./loginComp.vue?vue&type=template&id=3558f504"
import script from "./loginComp.vue?vue&type=script&lang=js"
export * from "./loginComp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__